import { CarbonCopyInput } from "../carbon-copy";
import { TicketDocumentInput } from "../ticket-document";

export class AddTicketCommentInput {
    public comment: string;
    public isPublic: boolean;
    public ticketId: number = 0;
    public carbonCopies: Array<CarbonCopyInput>;
    public deleteCarbonCopyIds: Array<number>;
    public ticketDocuments: Array<TicketDocumentInput>;

    constructor() {
        this.comment = '';
        this.isPublic = false;
        this.carbonCopies = new Array<CarbonCopyInput>();
        this.deleteCarbonCopyIds = new Array<number>();
        this.ticketDocuments = new Array<TicketDocumentInput>();
    }
}
